import defer from 'lodash/defer';

import { getCacheItem } from './cacheManager';

export default ({ update, options, cacheKey }) => {
  const connectedCache = getCacheItem(cacheKey);

  switch (options.setType) {
    case 'extend':
      connectedCache.query = { ...connectedCache.query, ...update };
      break;
    case 'extendRight':
      connectedCache.query = { ...update, ...connectedCache.query };
      break;
    default:
      connectedCache.query = update;
      break;
  }

  return new Promise((resolve) => {
    defer(() => {
      resolve();
    });
  });
};
